<template>
  <div class="chart-scroll-container">
    <div
      class="chart-container"
      :style="[
        {
          position: 'relative',
          height: '400px',
          width: chartWidth,
        },
      ]"
    >
      <canvas ref="chart" style="max-width: 100%" />
    </div>
  </div>
</template>
<script>
import { Chart } from 'chart.js'

export default {
  props: ['data', 'options', 'scrollable'],
  data: () => {
    return {
      chart: null,
    }
  },
  computed: {
    chartWidth() {
      const labelCount = (this.data && this.data.labels && this.data.labels.length) || 0
      if (!this.scrollable || labelCount < 2) return '100%'

      return `max(100%, ${labelCount * 44 + 40}px)`
    },
  },

  watch: {
    data: {
      handler(newData) {
        this.chart.data = this.generateData(newData)
        this.chart.update()
      },
    },
  },
  mounted() {
    const ctx = this.$refs.chart.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: this.generateData(this.data),
      options: {
        ...this.options,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },

          tooltip: {
            xAlign: 'center',
            yAlign: 'bottom',
            displayColors: false,
            callbacks: {
              label: function (context) {
                const tooltipMeta =
                  context.dataset.tooltipLabels[context.dataIndex].label.split('|')
                if (tooltipMeta.isFull && context.datasetIndex === 1) {
                  return ''
                }

                return tooltipMeta
              },
              title: function (context) {
                return context[0].dataset.tooltipLabels[context[0].dataIndex].title
              },
            },
          },
        },

        scales: {
          x: {
            stacked: true,
            grid: {
              drawBorder: false,
              title: false,
              display: false,
              color: '#F5F5F5',
            },
            ticks: {
              stepSize: 5,
              autoSkip: false,
              maxRotation: 90,
              minRotation: 0,
              font: {
                family: 'Source Sans Pro',
                size: 16,
                weight: 400,
              },
              color: '#333333',
            },
          },

          y: {
            stacked: this.options.stackedY,
            grid: {
              drawBorder: false,
              title: false,
              display: true,
              color: '#F5F5F5',
            },
            ticks: {
              stepSize: 2,
              font: {
                family: 'Source Sans Pro',
                size: 16,
                weight: 400,
              },
              color: '#333333',
            },
          },
        },
      },
    })
  },
  methods: {
    generateData(data) {
      return {
        ...data,
        datasets: this.data.datasets.map((set, i) => ({
          backgroundColor: set.bgColor,
          hoverBackgroundColor: set.bgColor,
          hoverBorderColor: set.borderColor,
          borderWidth: 2,
          borderColor: set.borderColor,
          barPercentage: this.options.barPercentage || 0.26,
          barThickness: this.calculateBarThickness(set.data.length),
          ...set,
        })),
      }
    },
    calculateBarThickness(dataLength) {
      if (this.scrollable) return this.options.barThickness || 22

      const screenWidth = window.innerWidth
      const maxBarWidth = screenWidth * 0.4

      return Math.min(maxBarWidth / dataLength, maxBarWidth)
    },
  },
}
</script>

<style scoped>
.chart-scroll-container {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  overflow-x: scroll;
  overscroll-behavior-x: contain;
  scrollbar-color: #979797 #f5f5f5;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  width: 100%;
}

.chart-scroll-container::-webkit-scrollbar {
  height: 8px;
}

.chart-scroll-container::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 8px;
}

.chart-scroll-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 8px;
}
</style>
